import ChinmayaVisionProgrammePage from "../components/pages/ChinmayaVisionProgramme";

export default ChinmayaVisionProgrammePage;
